import { FIREBASE_API } from "src/config-global";

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getMessaging, isSupported, onMessage } from "firebase/messaging";

export const firebaseConfig = {
  apiKey: FIREBASE_API.apiKey,
  authDomain: FIREBASE_API.authDomain,
  databaseURL: FIREBASE_API.databaseUrl,
  projectId: FIREBASE_API.projectId,
  storageBucket: FIREBASE_API.storageBucket,
  messagingSenderId: FIREBASE_API.messagingSenderId,
  appId: FIREBASE_API.appId,
};

export const app = initializeApp(firebaseConfig);
export const messaging = async () => (await isSupported()) && getMessaging(app);
